import { __assign, __rest } from "tslib";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import clsx from "clsx";
import React from "react";
import { getBaseProps } from "../../base-component";
import { useVisualRefresh } from "../../hooks/use-visual-mode";
import styles from "./styles.css.js";
// Can't use css variables for svg attributes
export var dimensionsByTheme = {
    "default": {
        viewBox: "0 0 14 14",
        indeterminate: "2.5,7 11.5,7",
        checked: "2.5,7 6,10 11,3",
        xy: 0.5,
        r: 1.5,
        size: 13
    },
    refresh: {
        viewBox: "0 0 16 16",
        indeterminate: "3.5,8 12.5,8",
        checked: "3.5,8 7,11 12,4",
        xy: 1,
        r: 2,
        size: 14
    }
};
var CheckboxIcon = function(_a) {
    var _b, _c;
    var checked = _a.checked, indeterminate = _a.indeterminate, _d = _a.disabled, disabled = _d === void 0 ? false : _d, restProps = __rest(_a, [
        "checked",
        "indeterminate",
        "disabled"
    ]);
    var baseProps = getBaseProps(restProps);
    var theme = useVisualRefresh() ? "refresh" : "default";
    var dimensions = dimensionsByTheme[theme];
    return /*#__PURE__*/ React.createElement("svg", __assign({
        className: styles.root,
        viewBox: dimensions.viewBox,
        "aria-hidden": "true",
        focusable: "false"
    }, baseProps), /*#__PURE__*/ React.createElement("rect", {
        className: clsx(styles["styled-box"], (_b = {}, _b[styles["styled-box-checked"]] = checked, _b[styles["styled-box-indeterminate"]] = indeterminate, _b[styles["styled-box-disabled"]] = disabled, _b)),
        x: dimensions.xy,
        y: dimensions.xy,
        rx: dimensions.r,
        ry: dimensions.r,
        width: dimensions.size,
        height: dimensions.size
    }), checked || indeterminate ? /*#__PURE__*/ React.createElement("polyline", {
        className: clsx(styles["styled-line"], (_c = {}, _c[styles["styled-line-disabled"]] = disabled, _c)),
        points: indeterminate ? dimensions.indeterminate : dimensions.checked
    }) : null);
};
export default CheckboxIcon; //# sourceMappingURL=index.js.map
